import { Component, OnInit } from '@angular/core';
import { buildErpPortalAuthUrl } from 'src/utils/portal-auth.util';

@Component({
  selector: 'app-login',
  template:
    '<div class="container py-5 text-center"><p class="text-muted">Opening sign in…</p></div>'
})
export class LoginComponent implements OnInit {
  constructor() {
    document.querySelector('.preloader')?.setAttribute('style', 'display: none;');
  }

  ngOnInit(): void {
    window.location.replace(buildErpPortalAuthUrl('login'));
  }
}
